import React, { useEffect } from "react";
import "./Login.css";
import google from "../../Assets/google.svg";
import config from "../../config";
import { Link, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { LoadingPage } from "../LoadingPage/LoadingPage";
import { useRecoilState } from "recoil";
import { isLoginLoader } from "../../utils/recoil";
import loginlogo from "../../Assets/uslot-ai-logo.png";
import { useTranslation } from "react-i18next";

const Login = () => {
  const tokenCookie = Cookies.get("token", { domain: config.cookieDomain });
  const isPaidCookie = Cookies.get("role", { domain: config.cookieDomain });
  const isTestTaken = Cookies.get("isTestAttended", {
    domain: config.cookieDomain,
  });
  const navigate = useNavigate();
  const [loading, setLoading] = useRecoilState(isLoginLoader);

  const { t } = useTranslation("login");

  useEffect(() => {
    if (tokenCookie && isPaidCookie === "ROLE_PAID_USER") {
      navigate("/instruction");
    } else if (tokenCookie) {
      navigate(-2);
    } else {
      setLoading(false);
    }
  }, []);

  return (
    <div className="login-page-main">
      {tokenCookie || loading ? (
        <LoadingPage />
      ) : (
        <>
          <div className="login-image-section !w-full p-4 relative md-max:hidden">
            <img src="/login-bg.webp" alt="" className="object-cover h-full w-full" />
          </div>
          <div className="login-content-section !w-full md-max:mt-10 pl-10">
            <div className="login-content !pl-0">
              <div>
                <Link to={"/"}>
                  {" "}
                  <img
                    src={loginlogo}
                    alt="logo"
                    className="object-contain h-[3.75rem]"
                  />
                </Link>
              </div>
              <div className="login-button-section flex flex-col items-center max-w-[80%]">
                <h1 className="!text-[58px] md-max:!text-[36px] font-semibold bg-gradient-to-br from-[#3B75DD] via-[#7768FC] to-[#3976F9] bg-clip-text text-transparent">
                  {t("heading")}
                </h1>
                {/* <p className="text-[#71717A] text-xl text-center">
                  Sign in with Google
                </p> */}
                <img src="/signup-illu-2.png" alt="" className="size-[350px] object-contain lg:hidden my-4" />
                <div className="w-max">
                  <div className="border rounded-full border-[#71717A] !w-full p-2 flex justify-center items-center">
                    <button
                      className="flex gap-2 items-center justify-center w-full px-2 hover:bg-gray-100"
                      onClick={() => [
                        setLoading(true),
                        (window.location.href =
                          config.domain + "/oauth2/authorization/google"),
                      ]}
                    >
                      <img src={"/g.webp"} alt="google" className="w-6 h-6" />
                      Continue with Google
                    </button>
                  </div>
                </div>
                <h2 className="text-[#71717A] !text-sm">
                  {t("contact")}{" "}
                  <span className="text-[#407BFF]">
                    <a href="mailto:info@uslotedu.com">{t("support")}</a>
                  </span>{" "}
                </h2>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Login;
